module.exports = __webpack_public_path__ + "media/images/products/retailers-newsletter-3-guardian-b758be619ce9f3bbb4f421b25cdb40d2.jpg";